/**
 * 날짜 관련 유틸리티 함수들
 */

/**
 * 날짜 문자열을 YYYY-MM-DDTHH:mm 형식으로 변환
 */
export const formatDateForInput = (dateString: string | null | undefined): string => {
  if (!dateString) return '';
  try {
    const date = new Date(dateString);
    return date.toISOString().slice(0, 16); // YYYY-MM-DDTHH:mm 형식으로 변환
  } catch (e) {
    console.error('날짜 변환 오류:', e);
    return '';
  }
};

/**
 * 날짜 문자열을 ISO 형식으로 변환
 */
export const formatDateForBackend = (dateString: string | null | undefined): string | null => {
  if (!dateString) return null;
  try {
    return new Date(dateString).toISOString();
  } catch (e) {
    console.error('날짜 변환 오류:', e);
    return null;
  }
};

/**
 * 날짜 문자열을 YYYY-MM-DD 형식으로 변환
 */
export const formatDateForDisplay = (dateString: string | null | undefined): string => {
  if (!dateString) return '';
  try {
    const date = new Date(dateString);
    return date.toISOString().slice(0, 10); // YYYY-MM-DD 형식으로 변환
  } catch (e) {
    console.error('날짜 변환 오류:', e);
    return '';
  }
};

/**
 * 날짜 객체를 YYYY-MM-DD 형식으로 변환
 */
export const formatDateToYYYYMMDD = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * ISO 문자열을 YYYY-MM-DD 형식으로 변환
 */
export const formatISOToYYYYMMDD = (dateString: string | null | undefined): string | null => {
  if (!dateString) return null;
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return null;
    return formatDateToYYYYMMDD(date);
  } catch (e) {
    console.error('날짜 변환 오류:', e);
    return null;
  }
};

export const formatDate = (date: string | Date | null): string => {
  if (!date) return '';
  const d = new Date(date);
  return d.toLocaleDateString('ko-KR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
};

/**
 * 서버 datetime 표시 (관제 메시지·시설 게시판·관제 자료실 등).
 * - 오프셋/Z 있으면 그 절대시각을 Asia/Seoul 로 표시
 * - 오프셋 없으면 Docker Postgres now() 관례상 UTC 벽시계로 보고 KST 변환
 * - 표시는 항상 Asia/Seoul
 */
export function formatDateTimeKst(value?: string | Date | null): string {
  if (value == null || value === '') return '-';
  try {
    let d: Date;
    if (value instanceof Date) {
      d = value;
    } else {
      const s = String(value).trim();
      const hasTz = /([zZ]|[+-]\d{2}:?\d{2})$/.test(s);
      // naive → UTC (…Z). 예전 +09:00 가정은 UTC DB 값을 9시간 늦게 보이게 함.
      const normalized = hasTz ? s : `${s.replace(' ', 'T')}Z`;
      d = new Date(normalized);
    }
    if (Number.isNaN(d.getTime())) return '-';
    return d.toLocaleString('ko-KR', {
      timeZone: 'Asia/Seoul',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    });
  } catch {
    return '-';
  }
}